import TabManager from "./TabManager";
import {CONFIG_META_INFO} from "../config/metainfo.config";

class FIleInfoManager {

    meta_info = CONFIG_META_INFO;

    listener = false;

    constructor() {
    }

    updatePath(path, jobId, outputId = 'no_output_id') {
        path = path.replace('no_job_id', jobId);
        path = path.replace('no_output_id', outputId);
        return path;
    }
    getFilenameFromOutput(output) {
        let lastSlashIndex = output.uri.lastIndexOf('/')
        return output.uri.substring(lastSlashIndex + 1)
    }

    openFileInfo(job, output) {
        let info = this.meta_info;
        let tab = TabManager.create();

        tab.name = this.getFilenameFromOutput(output);
        tab.path = this.updatePath(info[0].path, job.id, output.id);
        tab.type = info[0].type;
        tab.icon = info[0].icon;
        TabManager.createTab(tab);
        TabManager.openTab(tab);
    }
}

export default new FIleInfoManager()